import React, { useRef, useState } from 'react';
import styled from 'styled-components';

import ArrowRight from '@material-ui/icons/ArrowRight';

import useOutsideClickHandler from '../../../common-components/hooks/useOutsideClickHandler';
import usePopupClick from '../../../common-components/hooks/usePopupClick';
import { colors } from '../../WindowConfig';

interface IPopupMenuProps {}

const Container = styled.div<any>`
  position: absolute;
  background: ${colors.primary};
  z-index: 10;
  border: 1.5px solid ${colors.popupBorderColor};
  ${({ xPosition = '0' }) => {
    return `left: ${xPosition}px`;
  }};
  ${({ yPosition = '0' }) => {
    return `top: ${yPosition}px`;
  }};
`;

const Menu = styled.ul`
  display: flex;
  flex-direction: column;
  color: ${colors.yellowText};
  width: 250px;
  list-style: none;
  margin: 0;
  padding: 0px;
  min-width: 10em;

  ul {
    left: 98%;
    top: 0;
    margin-left: 1px;
    list-style: none;
    margin: 0;
    padding: 0px;
    min-width: 10em;
  }
`;

const MenuItem = styled.li`
  display: flex;
  position: relative;
  float: left;
  line-height: 30px;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  :hover > ul {
    display: block;
    position: absolute;
  }
  a {
    text-decoration: none;
  }
  li:hover {
    background-color: ${colors.popupMenuHoverColor};
    border: 2px solid ${colors.popupBorderColor};
    cursor: pointer;
  }
  :hover {
    background-color: ${colors.popupMenuHoverColor};
    border: 2px solid ${colors.popupBorderColor};
    cursor: pointer;
  }
`;

const SubMenu = styled.ul`
  display: none;
  border: 2px solid ${colors.popupBorderColor};
  background: ${colors.primary};
  width: 70%;
  :hover: {
    border: 2px solid ${colors.popupBorderColor};
  }
`;

const CustomArrowRightIcon = styled(ArrowRight)`
  color: ${colors.popupBorderColor};
`;
const SubMenuItem = styled.li`
  padding: 0 10px;
`;

const Label = styled.a``;
const PopupMenu: React.FunctionComponent<IPopupMenuProps> = (props) => {
  const [openPopupMenu, setOpenPopupMenu] = useState(false);
  const popupRef = useRef(null);
  const [position, setPosition] = useState({
    x: 0,
    y: 0,
  });
  usePopupClick((obj: any) => {
    setOpenPopupMenu(true);
    setPosition(obj);
  });
  useOutsideClickHandler(popupRef, () => setOpenPopupMenu(false));
  if (!openPopupMenu) {
    return null;
  }
  const json: any = {
    'Center Balltab / Pointer': {
      onClick: () => alert('Center Balltab / Pointer'),
    },
    'Range In/Out': {
      children: {
        '4096 (7491 km)': {},
        '2048 (3745 km)': {},
        '1024 (1873 km)': {},
        '512 (936 km)': {},
        '256 (468 km)': {},
        '128 (234 km)': {},
        '64 (117 km)': {},
        '32 (59 km)': {},
        '16 (29 km)': {},
        '8 (15 km)': {},
        '4 (7 km)': {},
        '2 (4 km)': {},
        '1 (2 km)': {},
        '0.5 (914 m)': {},
        '0.25 (457 m)': {},
        '0.125 (229 m)': {},
      },
    },
    Offset: {
      children: {
        Current: {},
        Previous: {},
        Ownship: {},
        'PRI Hook': {},
        'SEC Hook': {},
      },
    },
    'Go To View': {
      children: {
        unassigned: {},
      },
    },
    'Set View': {
      children: {
        unassigned: {},
      },
    },
    'Brg/Rng Line': {
      children: {
        OFF: {},
        Ownship: {},
        'PRI Hook': {},
        'SEC Hook': {},
        Geofix: {},
      },
    },
    Display: {
      children: {
        'Compass Rose': {},
        Overlays: {},
        Grids: {},
        'Geo Control': {},
        'Track Filter': {},
        'Video Radar': {},
      },
    },
    Orientation: {
      children: {
        'North-Up': {},
        'Heading-Up': {},
      },
    },
    'Velocity Leader': {
      children: {
        Absolute: {
          onClick: () => {
            alert('Velocity Leader - absolute clicked');
          },
        },
        Relative: {},
      },
    },
  };
  return (
    <Container xPosition={position.x} yPosition={position.y} ref={popupRef}>
      <Menu>
        {Object.keys(json).map((key: string, index: number) => {
          return (
            <MenuItem onClick={json[key].onClick} key={index}>
              <Label>{`${key}`}</Label>
              {json[key].children && <CustomArrowRightIcon />}
              {json[key].children && (
                <SubMenu>
                  {Object.keys(json[key].children).map(
                    (childKey: any, i: number) => {
                      return (
                        <SubMenuItem
                          key={i}
                          onClick={json[key].children[childKey].onClick}
                        >
                          <Label>{childKey}</Label>
                        </SubMenuItem>
                      );
                    }
                  )}
                </SubMenu>
              )}
            </MenuItem>
          );
        })}
      </Menu>
    </Container>
  );
};

export default PopupMenu;
